export default "__VITE_ASSET__Bzc9ZRVR__"